import { ListPagination } from "./ListPagination";

type CursorPaginationProps = {
  page: number;
  perPage: number;
  itemCount: number;
  hasNextPage: boolean;
  isPending?: boolean;
  resource: string;
  onPageChange: (page: number) => void;
};

export const CursorPagination = ({
  page,
  perPage,
  itemCount,
  hasNextPage,
  isPending = false,
  resource,
  onPageChange,
}: CursorPaginationProps) => (
  <ListPagination
    page={page}
    perPage={perPage}
    hasNextPage={hasNextPage}
    isPending={isPending}
    resource={resource}
    onPageChange={onPageChange}
    total={hasNextPage ? undefined : (page - 1) * perPage + itemCount}
  />
);
